import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { Provider } from '@angular/core';
import { enUS } from 'date-fns/locale';

export const NAPA_DEFAULT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MMM/dd/yyyy',
  },
  display: {
    dateInput: 'MMM/dd/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'MMM/dd/yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
};

export const NAPA_DEFAULT_DATEPICKER_PROVIDERS: Provider[] = [
  { provide: MAT_DATE_LOCALE, useValue: enUS },
  { provide: MAT_DATE_FORMATS, useValue: NAPA_DEFAULT_DATE_FORMATS },
  { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
];
